import { render, staticRenderFns } from "./ImportNotPossibleCard.vue?vue&type=template&id=7f87a82c&scoped=true&"
import script from "./ImportNotPossibleCard.vue?vue&type=script&lang=js&"
export * from "./ImportNotPossibleCard.vue?vue&type=script&lang=js&"
import style0 from "./ImportNotPossibleCard.vue?vue&type=style&index=0&id=7f87a82c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f87a82c",
  null
  
)

export default component.exports